/* eslint-disable */
import React, { ReactNode } from 'react';
import CircularProgress from '@mui/material/CircularProgress';

import './loading-btn.css';

import Button from '../Button';

type Props = {
  isLoading?: boolean;
  disabled?: boolean;
  children?: ReactNode;
  className?: string;
  onClick?: VoidFunction;
};

export const LoadingButton = ({
  isLoading = false,
  disabled = false,
  children,
  className,
  ...props
}: Props) => {
  return (
    <Button className={className} {...props} disabled={isLoading || disabled}>
      {children}
      {isLoading ? <CircularProgress className="btn-progress" /> : null}
    </Button>
  );
};
